import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import {
  BlNgUiComponentModule,
  NumberPlateViewComponent,
  ButtonCellRendererComponent,
  TooltipCellComponent,
  CheckboxCellRendererComponent,
} from '@blcloud/bl-ng-ui-component';
import {
  BlNgShareCommonModule,
  LabelModule,
  OrganizationComboBoxModule,
  SearchConditionPanelModule,
  AttachmentModule,
  CustomerVehicleSearchResourceService,
} from '@blcloud/bl-ng-share-module';
import {
  ProfileEntryResource,
  ProfileBulkMainEntryReqResource,
  ProfileEntryCustomerVehicleLinkReqResource,
  ProfileEntryCustomerVehicleLinkOptResource,
} from '@blcloud/bl-ng-resource';
import { ProfileEntriesPageComponent } from './profile-entries-page.component';
import { ProfileEntriesPageRoutingModule } from './profile-entries-page-routing.module';
import { ProfileMatchingModalComponent } from './profile-matching-modal/profile-matching-modal.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { CustomerSelectGuideComponent } from './customer-select-guide/customer-select-guide.component';
import { ProfileDataSelectModalComponent } from './profile-data-select-modal/profile-data-select-modal.component';
import { FixedFormatMemoModalComponent } from './fixed-format-memo-modal/fixed-format-memo-modal.component';
import { ReferenceTicketModalComponent } from './reference-ticket-modal/reference-ticket-modal.component';

@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    AgGridModule.withComponents([
      NumberPlateViewComponent,
      ButtonCellRendererComponent,
      TooltipCellComponent,
      CheckboxCellRendererComponent,
    ]),
    BlNgShareCommonModule,
    SearchConditionPanelModule,
    OrganizationComboBoxModule.forRoot(),
    ProfileEntriesPageRoutingModule,
    LabelModule,
    AttachmentModule,
  ],
  declarations: [
    ProfileEntriesPageComponent,
    ProfileMatchingModalComponent,
    ImageModalComponent,
    CustomerSelectGuideComponent,
    ProfileDataSelectModalComponent,
    FixedFormatMemoModalComponent,
    ReferenceTicketModalComponent,
  ],
  entryComponents: [
    ProfileMatchingModalComponent,
    ImageModalComponent,
    CustomerSelectGuideComponent,
    ProfileDataSelectModalComponent,
    FixedFormatMemoModalComponent,
    ReferenceTicketModalComponent,
  ],
  exports: [
    ProfileMatchingModalComponent,
    ImageModalComponent,
    CustomerSelectGuideComponent,
    ProfileDataSelectModalComponent,
    FixedFormatMemoModalComponent,
    ReferenceTicketModalComponent,
  ],
  providers: [
    ProfileEntryResource,
    ProfileBulkMainEntryReqResource,
    ProfileEntryCustomerVehicleLinkReqResource,
    ProfileEntryCustomerVehicleLinkOptResource,
    CustomerVehicleSearchResourceService,
  ]
})
export class ProfileEntriesPageModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ProfileEntriesPageModule
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-entries-page.module.ts